<style lang="less">

</style>
<template>
	<v-col :cols="element.attrs.cols" :xs="element.attrs.xs" :sm="element.attrs.sm" :md="element.attrs.md" :lg="element.attrs.lg" :style="style">
		<DisplayElement v-for="childElement in element.elements" :key="childElement.id" :element="childElement"></DisplayElement>			
	</v-col>
</template>

<script>
	import DisplayElement from "../TextEditor/DisplayElement.vue";
	export default {
		name: "DisplayColumn",
		props:{
			element: {type: Object},
		}, 
		components: {
			DisplayElement
		},
		data: () =>{
			return {			
			}
		},
		computed: {
			bindings(){
				var bindings = {
					id: this.element.id, 
				}
				return bindings;
			},
			style(){
				var styles = {}
				var imgUrl = this.element.attrs.imgUrl; 
				if( imgUrl ){
					styles['background-image'] = "url('" + imgUrl + "')";
					styles['background-size'] = "cover";
					styles['height'] = this.element.attrs.height;
				}
				return styles;
			},
			classes(){
				var object = {}
				object[this.element.attrs.padding] = this.element.attrs.padding ? true : false;
				object[this.element.attrs.margin] = this.element.attrs.margin ? true : false;
				object[this.element.attrs.alignment.text] = this.element.attrs.alignment.text ? true : false;
				object[this.element.attrs.typography.text] = this.element.attrs.typography.text ? true : false;
				object[this.element.attrs.colors.text+"--text"] = true;
				return object;
			},
		}
	}
</script>